// @flow
import React, { useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import CommonPage from 'app/common/templates/CommonPage';
import YaKlassRedirect from 'app/common/components/YaKlassRedirect';


type Props = {
  router: {
    push: (path: string) => void,
    [key: string]: mixed,
  },
  [key: string]: mixed,
}

const YaKlassPage = ({ router: { push } }: Props) => {
  const { id: studentId } = useSelector(state => state.settings.current, shallowEqual);

  const handleSuccess = useCallback(() => {
    if (studentId) {
      push(`/apps/${studentId}/assigned`);
    } else {
      push('/apps');
    }
  }, [push, studentId]);

  return (
    <CommonPage header="ЯКласс">
      <YaKlassRedirect onSuccess={handleSuccess} />
    </CommonPage>
  );
};

export default YaKlassPage;
